<template>
  <div class="OJProblemManagement">
    <div class="clearfix top">
      <div class="fl" style="margin-right:10px">
        <el-form ref="form" :model="form" :inline="true" size="mini">
          <el-form-item label="标题">
            <el-input v-model="form.title" placeholder="请输入比赛名称" size="mini" clearable @keyup.enter.native="adminGetOjContestList"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div class="fl">
        <el-form ref="form" :model="form" :inline="true" size="mini">
          <el-form-item label="所属">
            <el-select v-model="form.isPlatform" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="平台" value="1"></el-option>
              <el-option label="校区" value="2"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
      <div class="fl">
        <el-button type="primary" @click="adminGetOjContestList" icon="el-icon-search" size="mini">查询</el-button>

        <el-button type="primary" @click="add" icon="el-icon-plus" size="mini">新增比赛</el-button>
      </div>

    </div>
    <el-divider></el-divider>
    <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
      <!-- <el-table-column prop="id" label="排序号">
      </el-table-column> -->
      <el-table-column prop="rule_type" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.rule_type === 1">ACM</span>
          <span v-if="scope.row.rule_type === 2">OI</span>
          <span v-if="scope.row.rule_type === 3">IOI</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="比赛名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="start_date" label="起始时间">
      </el-table-column>
      <el-table-column prop="end_date" label="结束时间">
      </el-table-column>

      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.post_state===true">开启</span>
          <span v-if="scope.row.post_state===false">关闭</span>
        </template>

      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="students(scope.row)">学员列表</el-button>
          <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" size="mini" @click="goProblem(scope.row)">问题</el-button>
          <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix" style="margin-top: 20px;">
      <div class="fr" style=" text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  adminGetOjContestList,
  adminDeleteOjContest
}
  from "@/api/adminOj.js";

export default {
  data() {

    return {
      ifIgnore: 0,
      form: {
        resource: '',
        resource1: ''

      },
      page_no: 1,
      page_size: 20,
      total: 20,
      keyword: '',
      tableData: [

      ]
    }
  },
  mounted() {
    this.adminGetOjContestList()
  },
  methods: {
    students(row) {
      this.$router.push({
        name: 'stu',
        query: {
          contest_id: row.id,
        }
      })

    },
    // del(row) {
    //   this.$confirm('是否确认删除？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     adminDeleteOjContest({
    //       id: row.id,
    //       ifIgnore: this.ifIgnore
    //     }).then((res) => {
    //       console.log(res.is_create);


    //       if (res.is_create === true) {
    //         this.$message.success("删除成功");
    //         this.adminGetOjContestList()

    //       } else {
    //         this.$confirm(res.msg, "提示", {
    //           confirmButtonText: "确认",
    //           cancelButtonText: "取消",
    //           type: "warning",
    //         })
    //           .then(() => {
    //             this.ifIgnore = 1;
    //             this.adminDeleteOjContest();
    //             this.adminGetOjContestList()

    //           })
    //           .catch(() => {
    //             this.$message({
    //               type: "info",
    //               message: "已取消删除",
    //             });


    //           });
    //       }
       

    //     })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },
    del(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteOjContest({
          id: row.id,
          ifIgnore: 0
        }).then((res) => {

          if (res.is_delete === true) {
            this.$message.success("删除成功");
            this.adminGetOjContestList()
          } else {
            this.$confirm(res.msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              adminDeleteOjContest({
                id: row.id,
                ifIgnore: 1
              }).then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.adminGetOjContestList()
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    edit(row) {
      this.$router.push({
        name: 'addCompetitionManagement',
        query: {
          row: JSON.stringify(row),
        }
      })
    },
    adminGetOjContestList() {
      adminGetOjContestList({
        ...this.form,
        page_no: this.page_no,
        page_size: this.page_size
      }).then((res) => {
        console.log(res)
        this.tableData = res.ojConstestList
        this.total = res.total
      })
    },
    add() {
      this.$router.push({
        name: 'addCompetitionManagement'
      })
    },
    handleCurrent(val) {
      this.page_no = val
      this.adminGetOjContestList()

    },
    goProblem(row) {
      this.$router.push({
        name: 'problem',
        query: {
          row: JSON.stringify(row)
        }
      })
    },


  }

}
</script>
<style lang="scss" scoped>
.OJProblemManagement {
  margin: 10px;
  padding: 20px;

  background: white;
  border-radius: 5px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}
.top {
  font-size: 18px;
  font-weight: 300;
}
/deep/ .el-radio-group {
  margin-top: 7px;
}
/deep/ .el-divider--horizontal {
  margin-top: 0px;
}
</style>